import Birthdays from "./Birthdays";

export default Birthdays;
